import { render, staticRenderFns } from "./ChatMessageDivider.vue?vue&type=template&id=f572848e&scoped=true&"
import script from "./ChatMessageDivider.vue?vue&type=script&lang=js&"
export * from "./ChatMessageDivider.vue?vue&type=script&lang=js&"
import style0 from "./ChatMessageDivider.vue?vue&type=style&index=0&id=f572848e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f572848e",
  null
  
)

export default component.exports